import React, { useState, useEffect, useMemo } from "react";
import { useTable, useFilters, usePagination, useSortBy } from "react-table";
import { connect } from "react-redux";
import { useDrop } from 'react-dnd';
import { compose } from "redux";
import { Redirect } from "react-router-dom";
import { RiTableFill, RiTableLine } from "react-icons/ri";
import { PiCalendarDotsFill, PiCalendarDots } from "react-icons/pi";
import CalendarView from "../components/Control/CalendarView";
import ControlsHeader from "../components/Control/ControlsHeader";
import "../components/Control/controls.theme.css";
import LOADER from "../assets/images/loader.svg";
import { getControls_Report, editControl } from "../store/actions/riskActions";
import Popup from 'reactjs-popup';
import ControlOverlay from "../components/Control/ControlOverlay";
import FindingOverlay from "../components/Control/FindingOverlay.js";
import DraggableChecklistCard from "../components/Risk/DraggableChecklistCard.js";
import callOpenAIAPI, { callOpenAIAPIChecklist } from "../utils/openAI.js";
import { FiAlertTriangle, FiXCircle, FiClock, FiCheckCircle } from "react-icons/fi";



function Controls(props) {
    const { token, controls, activeDepartmentId, getControlsReportFN, editControlFN } = props;

    const [loading, setLoading] = useState(false);
    const [flattenedControls, setFlattenedControls] = useState([]);
    const [selectedView, setSelectedView] = useState("table");
    const [isControlOpen, setIsControlOpen] = useState(false);
    const [control_id, setControlId] = useState(null);
    const [risk_id, setRiskId] = useState(null);
    const [checklist, setChecklist] = useState([]);
    const [loadingAI, setLoadingAI] = useState(false); // For loading state during API call
    const [showChecklist, setShowCheklist] = useState(false); // Tracks when to show controls with animation
    const [findingId, setFindingID] = useState(null);
    const [isFindingOpen, setIsFindingOpen] = useState(false);
    const [effView, setEffView] = useState('All'); // 'All' | 'High' | 'Medium' | 'Low'


    const onRemoveControl = (id) => {
        setChecklist(prevControls => prevControls.filter(c => c.id !== id));
    };


    const compliancePillClass = (t) => {
        const map = {
            "NIST": "bg-blue-100 text-blue-800 border-blue-300",
            "COBIT": "bg-purple-100 text-purple-800 border-purple-300",
            "ISO 27001": "bg-emerald-100 text-emerald-800 border-emerald-300",
            "GDPR": "bg-amber-100 text-amber-900 border-amber-300",
        };
        return map[t] || "bg-gray-100 text-gray-800 border-gray-300";
    };

    useEffect(() => {
        if (activeDepartmentId) {
            setLoading(true);
            getControlsReportFN(activeDepartmentId).finally(() => setLoading(false));
            //console.log(controls);
        }
    }, [activeDepartmentId, getControlsReportFN]);

    useEffect(() => {
        if (controls && controls?.length > 0) {
            //console.log("Controls before flat:" , controls);
            const allControls = controls
                .filter((control) =>
                    control.controls.some(
                        (c) =>
                            c.controlDetails !== null ||
                            c.controlType !== null ||
                            c.controlDefinition !== null
                    )

                )
                .flatMap((control) =>
                    control.controls.map((c) => ({
                        ...c,
                        riskId: control.riskId,
                        title: control.title,
                        owner: c.owner,
                        is_secondline: c.secondline
                    }))
                );
            console.log("Flattend ", allControls)
            setFlattenedControls(allControls);
        } else {
            setFlattenedControls([]);
        }
    }, [controls]);

    const closeCreation = async (data, control_id) => {
        console.log("Data:", data, "ID", control_id)
        setChecklist([])
        setIsControlOpen(false)
        await updateServerData(data, control_id);
        getControlsReportFN(activeDepartmentId)

    }

    const closeFinding = async (data, finding_id) => {
        setIsFindingOpen(false)
        setFindingID(null)
        console.log("close finding", data, " ", finding_id)

    }

    const fetchAISuggestions = async (title, details) => {
        setShowCheklist(false);
        setLoadingAI(true);

        try {
            const aiResponse = await callOpenAIAPIChecklist(title, details);

            console.log("aiResponse1", aiResponse);

            const parsedControls = aiResponse.map((item, i) => ({
                id: crypto.randomUUID?.() || `control-${i}`,
                text: item,   // store the string under "text"
            }));

            setChecklist(parsedControls);

            console.log("aiResponse", parsedControls);

            setTimeout(() => {
                setShowCheklist(true);
            }, 300);
        } catch (error) {
            console.error("Error fetching AI suggestions:", error);
        } finally {
            setLoadingAI(false);
        }
    };


    const updateServerData = async (data, control_id) => {


        const updatedData = { ...data };

        // Add one day to StartDate and EndDate if they exist
        if (updatedData.StartDate) {
            const startDate = new Date(updatedData.StartDate);
            startDate.setDate(startDate.getDate() + 1);
            updatedData.StartDate = startDate.toISOString().split('T')[0]; // Format as YYYY-MM-DD
        }

        if (updatedData.EndDate) {
            const endDate = new Date(updatedData.EndDate);
            endDate.setDate(endDate.getDate() + 1);
            updatedData.EndDate = endDate.toISOString().split('T')[0]; // Format as YYYY-MM-DD
        }

        console.log("CONTROL DATA AFTER ADJUSTMENT", updatedData);

        setLoading(true);
        await editControlFN(risk_id, control_id, updatedData);
        setLoading(false);

    }

    const columns = React.useMemo(
        () => [
            {
                Header: "Control Title",
                accessor: "controlDetails",
                Cell: ({ value }) => (
                    <div style={{ whiteSpace: "normal", wordWrap: "break-word", width: "400px" }}>
                        {value}
                    </div>
                ),
            },
            {
                Header: "Compliance Types",
                accessor: "complianceTypes",
                Cell: ({ value }) => (
                    <div className="flex flex-wrap gap-1">
                        {Array.isArray(value) && value.length > 0
                            ? value.map((c, i) => (
                                <span
                                    key={i}
                                    className={`px-2 py-0.5 text-xs rounded border ${compliancePillClass(c)}`}
                                >
                                    {c}
                                </span>
                            ))
                            : <span className="text-gray-400 text-xs">None</span>}
                    </div>
                ),
            },
            { Header: "Control Type", accessor: "controlType" },
            {
                Header: "Control Efficiency",
                accessor: "efficiencyLevel",
                Cell: ({ value }) => (
                    <div className="relative w-32 h-6 bg-gray-200 rounded-full flex items-center">
                        <div
                            className="absolute h-full rounded-full"
                            style={{
                                width: `${value || 0}%`,
                                backgroundColor:
                                    value >= 75 ? "#00AFB9" : value >= 50 ? "#FFD166" : "#EF476F",
                            }}
                        />
                        <span className="relative text-white ml-2 text-xs">
                            {value ? `${parseFloat(value).toFixed(0)}%` : "0%"}
                        </span>
                    </div>
                ),
            },
            { Header: "Control Period", accessor: "controlPeriod" },
            { Header: "Risk Title", accessor: "title" },
            {
                Header: "Owner",
                accessor: (row) =>
                    `${row.owner?.firstName || ""} ${row.owner?.lastName || ""}`,
                id: "owner",
            },
        ],
        []
    );

    //console.log("flattened controls:", flattenedControls);


    const renderPagination = () => (
        <div className="pagination flex justify-center items-center mt-4">
            <div className="flex items-center space-x-2">
                <button
                    onClick={() => gotoPage(0)}
                    disabled={!canPreviousPage}
                    className={`pagination-button ${!canPreviousPage ? "disabled" : ""}`}
                >
                    « First
                </button>
                <button
                    onClick={() => previousPage()}
                    disabled={!canPreviousPage}
                    className={`pagination-button ${!canPreviousPage ? "disabled" : ""}`}
                >
                    ‹ Prev
                </button>
                <span>
                    Page <strong>{pageIndex + 1}</strong> of{" "}
                    <strong>{Math.ceil(flattenedControls?.length / pageSize) || 1}</strong>
                </span>
                <button
                    onClick={() => nextPage()}
                    disabled={!canNextPage}
                    className={`pagination-button ${!canNextPage ? "disabled" : ""}`}
                >
                    Next ›
                </button>
                <button
                    onClick={() => gotoPage(Math.ceil(flattenedControls?.length / pageSize) - 1)}
                    disabled={!canNextPage}
                    className={`pagination-button ${!canNextPage ? "disabled" : ""}`}
                >
                    Last »
                </button>
            </div>
            {/* <div className="ml-4">
                <label>
                    Page Size:
                    <select
                        value={pageSize}
                        onChange={(e) => setPageSize(Number(e.target.value))}
                        className="ml-2 border rounded-md p-1"
                    >
                        {[10, 20, 30, 40, 50].map((size) => (
                            <option key={size} value={size}>
                                {size}
                            </option>
                        ))}
                    </select>
                </label>
            </div> */}
        </div>
    );

    const handleIconClick = (view) => setSelectedView(view);


    const [query, setQuery] = useState('');
    const [typeView, setTypeView] = useState('All');
    const [statusView, setStatusView] = useState('All');

    // Build type options from your data (e.g., controlType: 'Mitigative', 'Preventive', etc.)
    const typeOptions = useMemo(() => ['All', ...Array.from(new Set(controls.map(c => c.controlType).filter(Boolean)))], [controls]);

    // If you want dynamic counts from your controls array:
    // --- CONTROL STATS (using flattenedControls) ---
    const counts = useMemo(() => {
        const normType = (s = "") => s?.toString().trim().toLowerCase();
        let total = flattenedControls?.length || 0;
        let highEff = 0;
        let preventive = 0;
        let detective = 0;

        (flattenedControls || []).forEach((c) => {
            const eff = Number(c.efficiencyLevel ?? 0);
            if (eff >= 75) highEff++;
            const t = normType(c.controlType);
            if (t === "preventive") preventive++;
            if (t === "detective") detective++;
        });

        return { total, highEff, preventive, detective };
    }, [flattenedControls]);

    // --- FILTERED CONTROLS (for search + filters) ---
    const effBucket = (n) => {
        const v = Number(n ?? 0);
        if (v >= 75) return 'high';
        if (v >= 40) return 'medium';
        return 'low';
    };

    const filteredControls = useMemo(() => {
        const q = (query || "").toLowerCase().trim();
        const norm = (v) => (v ?? "").toString().toLowerCase();
        const wantType = (typeView || "All").toLowerCase();
        const wantStatus = (statusView || "All").toLowerCase();
        const wantEff = (effView || "All").toLowerCase();

        const statusOf = (c) => {
            const now = new Date();
            const s = c.startDate ? new Date(c.startDate) : null;
            const e = c.endDate ? new Date(c.endDate) : null;
            if (e && e < now) return "closed";
            if (s && s > now) return "open";
            return "in progress";
        };

        return (flattenedControls || []).filter((c) => {
            // text match
            const hay = [
                norm(c.title),
                norm(c.controlDetails),
                norm(c.controlDefinition),
                norm(Array.isArray(c.complianceTypes) ? c.complianceTypes.join(",") : c.complianceTypesRaw || ""),
                norm(c.owner?.firstName), norm(c.owner?.lastName),
                norm(c.controlType),
            ].join(" ");
            if (q && !hay.includes(q)) return false;

            // type filter
            if (wantType !== "all" && (c.controlType || "").toLowerCase() !== wantType) return false;

            // status filter
            if (wantStatus !== "all" && statusOf(c) !== wantStatus) return false;

            // efficiency filter
            if (wantEff !== "all" && effBucket(c.efficiencyLevel) !== wantEff) return false;

            return true;
        });
    }, [flattenedControls, query, typeView, statusView, effView]);



    const {
        getTableProps,
        getTableBodyProps,
        headerGroups,
        prepareRow,
        page,
        canPreviousPage,
        canNextPage,
        nextPage,
        previousPage,
        gotoPage,
        setPageSize,
        state: { pageIndex, pageSize },
    } = useTable(
        {
            columns,
            data: filteredControls,
            initialState: { pageIndex: 0, pageSize: 8 },
            autoResetPage: false,
            autoResetSortBy: false,
            autoResetFilters: false,
        },
        useFilters,
        useSortBy,
        usePagination
    );

    function StatCard({ label, value }) {
        let Icon;
        let iconColor = "";

        switch (label) {
            case "Total Findings":
                Icon = FiAlertTriangle;
                iconColor = "text-gray-400";
                break;
            case "In Progress":
                Icon = FiXCircle;
                iconColor = "text-red-500";
                break;
            case "Open Findings":
                Icon = FiClock;
                iconColor = "text-blue-500";
                break;
            case "Closed":
                Icon = FiCheckCircle;
                iconColor = "text-green-500";
                break;
            default:
                Icon = null;
        }

        return (
            <div className="rounded-xl border border-gray-200 bg-white p-4 flex flex-col justify-between">
                <div className="flex items-center justify-between">
                    <div className="text-xs text-gray-500">{label}</div>
                    {Icon && <Icon className={`w-4 h-4 ${iconColor}`} />}
                </div>
                <div className="mt-1 text-2xl font-semibold text-[#0E0E0E]">{value}</div>
            </div>
        );
    }

    return token ? (
        <div className="w-full bg-[#F8F8F8] min-h-[100dvh] overflow-y-auto pb-28">
            <div className="px-6 md:px-10 xl:px-16 2xl:px-24 pt-8 md:pt-5">
                <div className="flex items-center justify-between mb-6">
                    <div>
                        <h1 className="text-xl md:text-2xl font-medium tracking-wide text-[#0E0E0E]">
                            {selectedView === "calendar" ? "Controls Calendar" : "Control Management"}
                        </h1>
                        <p className="text-xs md:text-sm text-gray-600">
                            {selectedView === "calendar"
                                ? "View controls scheduled across the calendar"
                                : "Track and manage security controls across your organization"}
                        </p>
                    </div>

                    {/* Right: View toggle buttons */}
                    <div className="flex items-center gap-3">
                        <button
                            onClick={() => handleIconClick("table")}
                            className={`flex items-center gap-2 border rounded-lg px-3.5 py-1.5 text-sm font-medium transition 
        ${selectedView === "table"
                                    ? "bg-[#F3F4F6] text-[#0E0E0E] border-gray-300 shadow-sm"
                                    : "bg-white text-gray-600 hover:bg-gray-50 border-gray-300"}`}
                        >
                            {selectedView === "table" ? (
                                <RiTableFill size={18} className="text-[#0E0E0E]" />
                            ) : (
                                <RiTableLine size={18} className="text-gray-500" />
                            )}
                            <span>Table View</span>
                        </button>

                        <button
                            onClick={() => handleIconClick("calendar")}
                            className={`flex items-center gap-2 border rounded-lg px-3.5 py-1.5 text-sm font-medium transition 
        ${selectedView === "calendar"
                                    ? "bg-[#F3F4F6] text-[#0E0E0E] border-gray-300 shadow-sm"
                                    : "bg-white text-gray-600 hover:bg-gray-50 border-gray-300"}`}
                        >
                            {selectedView === "calendar" ? (
                                <PiCalendarDotsFill size={18} className="text-[#0E0E0E]" />
                            ) : (
                                <PiCalendarDots size={18} className="text-gray-500" />
                            )}
                            <span>Calendar View</span>
                        </button>
                    </div>
                </div>


                {selectedView === "table" && (
                    <>
                        {/* Stat Cards */}
                        <div className="mt-5 grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-3">
                            <StatCard label="Total Controls" value={counts.total} />
                            <StatCard label="High Effectiveness (≥75%)" value={counts.highEff} />
                            <StatCard label="Preventive" value={counts.preventive} />
                            <StatCard label="Detective" value={counts.detective} />
                        </div>

                        <ControlsHeader
                          query={query}
                          setQuery={setQuery}
                          typeView={typeView}
                          setTypeView={setTypeView}
                          effView={effView}
                          setEffView={setEffView}
                          statusView={statusView}
                          setStatusView={setStatusView}
                          selectedView={selectedView}
                          setSelectedView={setSelectedView}
                        />
                        <div className="bg-white rounded-lg border border-gray-200 overflow-hidden mt-2">
                          <div className="px-6 py-4 border-b border-gray-200">
                            <h3 className="text-gray-900">Controls List</h3>
                            <p className="text-sm text-gray-500">
                              {(filteredControls?.length ?? 0)} controls found (Page {pageIndex + 1} of {Math.max(1, Math.ceil((flattenedControls?.length || 0) / pageSize))})
                            </p>
                          </div>
                        </div>
                    </>)}

                {/* Table / Calendar Toggle */}
                <div className="relative">
                    {/* <div className="flex justify-end mb-8">
                        <div className="absolute top-46 right-14 flex space-x-4">
                            <button
                                onClick={() => handleIconClick("table")}
                                className={`border px-4 py-2 bg-[#F8F8F8] hover:bg-gray-100 rounded ${selectedView === "table"
                                        ? "text-[#3b3b3b]"
                                        : "text-gray-500"
                                    }`}
                            >
                                {selectedView === "table" ? (
                                    <RiTableFill size={16} />
                                ) : (
                                    <RiTableLine size={16} />
                                )}
                            </button>
                            <button
                                onClick={() => handleIconClick("calendar")}
                                className={`border px-4 py-2 bg-[#F8F8F8] hover:bg-gray-100 rounded ${selectedView === "calendar"
                                        ? "text-[#3b3b3b]"
                                        : "text-gray-500"
                                    }`}
                            >
                                {selectedView === "calendar" ? (
                                    <PiCalendarDotsFill size={16} />
                                ) : (
                                    <PiCalendarDots size={16} />
                                )}
                            </button>
                        </div>
                    </div> */}
                  {selectedView === "table" ? (
  <>
    {/* wider wrapper (less px padding) */}
    <div className="bg-white border border-gray-200 rounded-2xl shadow-sm mt-6 px-3 md:px-4 xl:px-6 2xl:px-8 py-6">
      <div className="table-wrapper shadow-lg border border-gray-300 rounded-2xl overflow-hidden">

        <table
          {...getTableProps()}
          className="main-table w-full text-sm text-gray-800"
          style={{
            borderCollapse: "separate",
            borderSpacing: 0,
            tableLayout: "fixed",
            width: "100%",
          }}
        >
          <thead className="bg-white" style={{ background: "#fff" }}>
            {headerGroups.map((headerGroup) => {
              const cols = headerGroup.headers;
              const lastIdx = cols.length - 1;

              return (
                <tr
                  {...headerGroup.getHeaderGroupProps()}
                  className="border-b border-gray-300"
                  style={{ background: "#fff" }}
                >
                  {/* 1️⃣ Control ID */}
                  <th
                    className="text-left text-[13px] text-gray-800 font-semibold"
                    style={{
                      background: "#fff",
                      padding: "0.3rem 0.75rem",
                      lineHeight: "1rem",
                      borderTopLeftRadius: "8px",
                      width: "140px",
                      whiteSpace: "nowrap",
                    }}
                  >
                    <div className="flex items-center gap-1">Control ID</div>
                  </th>

                  {/* existing dynamic headers (Risk Title removed) */}
                  {cols.map((column, idx) => {
                    const isFirst = idx === 0;
                    const isLast = idx === lastIdx;

                    if (column.Header === "Risk Title") return null;

                    let width;
                    if (column.Header === "Compliance Types") width = "220px";
                    else if (
                      column.id === "controlTitle" ||
                      column.id === "controlDetails"
                    )
                      width = "25%";

                    return (
                      <th
                        {...column.getHeaderProps(
                          column.getSortByToggleProps()
                        )}
                        className="cursor-pointer text-left text-[13px] text-gray-800 font-semibold"
                        style={{
                          background: "#fff",
                          padding: "0.3rem 0.75rem",
                          lineHeight: "1rem",
                          borderTopLeftRadius: isFirst ? "8px" : undefined,
                          borderTopRightRadius: isLast ? "8px" : undefined,
                          width,
                        }}
                      >
                        <div className="flex items-center gap-1">
                          {column.render("Header")}
                          <span className="opacity-70">
                            {column.isSorted
                              ? column.isSortedDesc
                                ? " 🔽"
                                : " 🔼"
                              : ""}
                          </span>
                        </div>
                      </th>
                    );
                  })}

                  {/* 2️⃣ Findings header */}
                  <th
                    className="text-left text-[13px] text-gray-800 font-semibold"
                    style={{
                      background: "#fff",
                      padding: "0.3rem 0.75rem",
                      lineHeight: "1rem",
                      width: "110px",
                      whiteSpace: "nowrap",
                    }}
                  >
                    <div className="flex items-center gap-1">Findings</div>
                  </th>

                  {/* ❌ REMOVED empty action column */}
                </tr>
              );
            })}
          </thead>

          <tbody {...getTableBodyProps()}>
            {page.length === 0 ? (
              <tr>
                <td
                  colSpan={headerGroups[0].headers.length + 2} // ← FIXED (was +3)
                  className="px-4 py-10 text-center text-sm text-gray-500"
                >
                  No controls match your filters.
                </td>
              </tr>
            ) : (
              page.map((row) => {
                prepareRow(row);
                return (
                  <tr
                    {...row.getRowProps({
                      onClick: () => {
                        const matchingRisk = controls.find((risk) =>
                          risk.controls?.some?.(
                            (ctrl) => ctrl.controlID === row.original.controlID
                          )
                        );
                        if (matchingRisk) setRiskId(matchingRisk.riskId);
                        setControlId(row.original.controlID);
                        setTimeout(() => setIsControlOpen(true), 0);
                      },
                    })}
                    className="group transition-colors duration-200 cursor-pointer"
                  >
                    {/* 1️⃣ Control ID */}
                    <td
                      className="overflow-hidden text-ellipsis whitespace-nowrap border-t border-gray-200 group-hover:bg-[#F8F8F8]"
                      style={{ padding: "0.65rem 1rem", width: 140 }}
                    >
                      {`CTRL-${row.original.controlID ?? ""}`}
                    </td>

                    {/* Dynamic cells */}
                    {row.cells.map((cell) => {
                      const header = cell.column.Header;
                      if (header === "Risk Title") return null;

                      // Effectiveness pill (High/Medium/Low as black pill)
                      if (
                        /^(efficiency|controlEfficiency|Efficiency|efficiency_level|EfficiencyLevel)$/i.test(
                          cell.column.id
                        )
                      ) {
                        const raw =
                          typeof cell.value === "number"
                            ? cell.value
                            : Number(
                                row.original.efficiencyLevel ??
                                  row.original.controlEfficiency ??
                                  row.original.efficiency ??
                                  0
                              );
                        const val = Math.max(0, Math.min(100, raw));
                        const label = val >= 75 ? "High" : val >= 40 ? "Medium" : "Low";
                        return (
                          <td
                            {...cell.getCellProps()}
                            className="border-t border-gray-200 group-hover:bg-[#F8F8F8]"
                            style={{ padding: "0.65rem 1rem" }}
                          >
                            <span className="pill-black px-2 py-1 rounded text-xs font-medium">
                              {label}
                            </span>
                          </td>
                        );
                      }

                      // Control title/details block preserved
                      if (
                        cell.column.id === "controlDetails" ||
                        cell.column.id === "control_title" ||
                        cell.column.id === "ControlDetails" ||
                        cell.column.id === "controlTitle"
                      ) {
                        return (
                          <td
                            {...cell.getCellProps()}
                            className="border-t border-gray-200 group-hover:bg-[#F8F8F8] align-top"
                            style={{ padding: "0.65rem 1rem" }}
                          >
                            <div className="flex flex-col min-w-[320px] max-w-[560px] pr-2">
                              <span className="font-medium text-gray-800">
                                {cell.render("Cell")}
                              </span>

                              {row.original.controlDefinition && (
                                <span className="text-xs text-gray-500 mt-0.5 line-clamp-2">
                                  {row.original.controlDefinition}
                                </span>
                              )}
                            </div>
                          </td>
                        );
                      }

                      // Normal cell
                      return (
                        <td
                          {...cell.getCellProps()}
                          className="overflow-hidden text-ellipsis whitespace-normal border-t border-gray-200 group-hover:bg-[#F8F8F8]"
                          style={{ padding: "0.65rem 1rem" }}
                        >
                          {cell.render("Cell")}
                        </td>
                      );
                    })}

                    {/* Findings cell */}
                    <td
                      className="overflow-hidden text-ellipsis whitespace-nowrap border-t border-gray-200 group-hover:bg-[#F8F8F8]"
                      style={{ padding: "0.65rem 1rem", width: 110 }}
                    >
                      {(() => {
                        const num = Number(row.original.findingNumber ?? 0);
                        if (isNaN(num)) return "-";
                        const cls = num === 0 ? "badge-green" : "badge-red";
                        return <span className={cls}>{num}</span>;
                      })()}
                    </td>

                    {/* ❌ REMOVED empty td */}
                  </tr>
                );
              })
            )}
          </tbody>
        </table>
      </div>

      <div className="mt-4">{renderPagination()}</div>
    </div>
  </>
) : (
  <div className="mt-12">
    <CalendarView events={filteredControls} />
  </div>
)}










                </div>

                {/* Control Popup */}
                <Popup
                    open={isControlOpen}
                    onClose={() => setIsControlOpen(false)}
                    modal
                    closeOnDocumentClick={false}
                    closeOnEscape
                    contentStyle={{
                        overflow: "auto",
                        maxHeight: "80vh",
                        width: "900px",
                        marginTop: "14vh",
                    }}
                >
                    <ControlOverlay
                        key={control_id || "new-control"}
                        closeControl={closeCreation}
                        control_id={control_id}
                        risk_id={risk_id}
                        fetchAISuggestions={fetchAISuggestions}
                        loadingAI={loadingAI}
                        setFindingID={setFindingID}
                    />
                </Popup>

                {/* Floating AI Suggested Controls */}
                {checklist?.length > 0 && (
                    <div
                        className={`absolute right-6 top-28 w-[340px] bg-transparent rounded-md p-4 transition-all duration-500 ease-in-out ${showChecklist
                            ? "opacity-100 translate-y-0"
                            : "opacity-0 translate-y-4"
                            }`}
                        style={{ zIndex: 1050, pointerEvents: "auto" }}
                    >
                        {checklist.map((control) => (
                            <DraggableChecklistCard
                                key={control.id}
                                control={control}
                                onRemove={() => onRemoveControl(control.id)}
                            />
                        ))}
                    </div>
                )}
            </div>
        </div>
    ) : (
        <Redirect to="/login" />
    );


}

const mapStateToProps = (state) => {
    console.log("Controls:", state.risk.risk_controls)
    return {
        token: state.auth.token,
        controls: state.risk.risk_controls,
        activeDepartmentId: state.department.activeDepartmentId,
    }
};

const mapDispatchToProps = (dispatch) => ({
    getControlsReportFN: (departmentId) => dispatch(getControls_Report(departmentId)),
    editControlFN: (risk_id, control_id, control) => dispatch(editControl(risk_id, control_id, control)),
});

export default compose(connect(mapStateToProps, mapDispatchToProps))(Controls);